<template>
    <div class="page_top_NoLogin" :style="isLogin == 0 ? 'height:595px' : 'height:450px'">
        <div class="head_Navigat">
            <div class="head_logo" @click="$router.push('/')">
                <div class="logo">
                    <img :src="$global.Local + company.logo"/>
                </div>
                <div class="logo_title">
                    相君电子印章
                </div>
            </div>

            <div class="head_menu">
                <div class="menu_Product" v-for="(item,index) in menuData" :key="item.id"
                     :style="login == 0 ? 'margin-left: 20px;' : 'margin-left: 30px;'">
                    <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{item.text}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="(newItem || item.text)" v-for="(newItem,newIndex) in item.list"
                                              :key="newIndex">{{newItem.text || newItem}}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="head_phoe" v-if="login == 0">
                客服电话：{{company.phone}}
            </div>
            <div class="head_regist">
                <router-link to="/login">
                    <div class="login" v-if="login == 0">登录</div>
                </router-link>

                <router-link to="/loginRegist">
                    <div class="regist" v-if="login == 0">注册</div>
                </router-link>

                <div class="head_user" v-if="login == 1" :style="login == 1 ? 'margin-left: 50px;':''">
                    <img :src="$global.Local + $store.store.state.userData.headImg"
                         v-if="$store.store.state.userData.headImg"/>
                    <img src="../../assets/logo.png" v-else/>
                    <el-popconfirm @confirm="handlLogout" confirm-button-text='确定' cancel-button-text='取消'
                                   icon="el-icon-info"
                                   icon-color="red" title="是否退出登录？">
                        <el-button slot="reference" ref="popconfirm">
                            {{$store.store.state.userData.name ? $store.store.state.userData.name : ''}}用户，您已登录
                        </el-button>
                    </el-popconfirm>
                </div>
                <div class="trial" @click="open()">免费试用</div>
            </div>
        </div>
        <div class="head_introduce" :style="isLogin == 0 ? 'height:630px' : 'height:350px'">
            <div class="xiangJun_title">
                {{title ? title : company.fullName}}
            </div>
            <div class="xiangJun_desc" v-if="isLogin == 0">
                <div class="desc_text1">为企业提供电子合同全生命周期智能管理服务，帮助企业实现降本增效</div>
                <div class="desc_text2">超过100家500强企业都在使用</div>
            </div>
            <div class="xiangJun_btn" v-if="isLogin == 0" @click="open()">
                免费试用
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapActions, mapState} from 'vuex';

    export default {
        data() {
            return {
                login: 0,
                userName: '',
                company: '',
                menuData: [{
                    id: 5,
                    text: '首页',
                    list: [{
                        text: '网站首页',
                        path: '/'
                    }, {
                        text: '登录首页',
                        path: '/loginMenu'

                    },]
                },
                    {
                        id: 0,
                        text: '产品',
                        list: [{
                            text: '我们的产品',
                            path: ''
                        },]
                    },
                    {
                        id: 1,
                        text: '价格',
                        list: [{
                            text: '我们的价格',
                            path: ''
                        },]
                    },
                    {
                        id: 2,
                        text: '新闻资讯',
                        list: [{
                            text: '新闻列表',
                            path: '/newsList'
                        },]
                    },
                    {
                        id: 3,
                        text: '客户案例',
                        list: [{
                            text: '客户案例',
                            path: '/anLi'
                        },]
                    },
                    {
                        id: 5,
                        text: '使用说明',
                        list: [{
                            text: '视频教程',
                            path: '/ukeyVideo'
                        },
                        {
                            text: '驱动下载',
                            path: '/video/驱动文件.zip'
                        },
                        ]
                    },
                    {
                        id: 4,
                        text: '关于我们',
                        list: [{
                            text: '关于我们',
                            path: '/aboutUs'
                        },]
                    }
                ]
            }
        },
        props: ['isLogin', 'title'],
        watch: {
            menuData(newVal, oldVal) {
                console.log(newVal, 'newVal')
            },
            '$store.store.state.pidearData': function (newVal, oldVal) {
                //你需要执行的代码
                this.company = newVal
            }

        },
        methods: {
            open() { //
                if (localStorage.getItem('login') == 1) {

                    this.$router.push('loginMenu');
                } else {
                    this.$confirm('免费试用需要先进行注册, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: '',
                        center: true
                    }).then(() => {
                        this.$router.push('loginRegist');
                    }).catch(() => {
                    });
                }

            },
            handleCommand(command) {
                console.log(command);
                if (command.text == '我们的产品') {
                    this.$router.push({
                        name: 'registAgreement',
                        params: {
                            type: 5,
                            title: "相君科技平台产品"
                        }
                    })
                }
                if (command.text == '我们的价格') {
                    this.$router.push({
                        name: 'cnde',
                        params: {
                            type: 6,
                            title: "相君科技平台价格"
                        }
                    })
                }
                this.$router.push(command.path);


                // if(command.path){
                //   this.$router.push(command.path);
                // }else{
                //   if(command == '新闻资讯'){
                //     alert(2)
                //     this.$parent.offset();

                //   }
                // }


            },
            handlCheckLogin() {
                this.$router.push({
                    name: '/login'
                });
            },
            handlLogout() {
                let _this = this;
                let param = new FormData();
                param.append('token', _this.$global.token);
                _this.api.logout(param).then(res => {
                    console.log(res);
                    _this.$message.success('退出登录');
                    _this.$router.push({
                        path: '/'
                    })
                    /*  var storage = window.localStorage;
                      storage.clear();*/
                    localStorage.removeItem('user_token');
                    localStorage.removeItem('user_data');
                    localStorage.removeItem('login');
                    localStorage.removeItem('lastTime');
                    location.reload();
                })
            }
        },
        created() {
            this.company = JSON.parse(localStorage.getItem('pidearData')) || this.$store.store.state.pidearData
        },
        mounted() {
            let _this = this;
            _this.login = localStorage.getItem('login') ? localStorage.getItem('login') : 0;
        },
    }
</script>

<style scoped lang="less">
    @import '../../../static/less/xm.less';

    /deep/ .el-button {
        border: none;
        color: #fff;
        font-size: 18px;
        background: #fff0;
    }

    /deep/ .el-button:hover {
        border: none;
        background: #fff0;
    }

    /deep/ .el-dropdown-link {
        cursor: pointer;
        color: #ffffff;
    }

    /deep/ .el-dropdown {
        font-size: 18px;
    }

    a {
        text-decoration: none;
    }

    .page_top_NoLogin {
        width: @a;
        position: relative;
        background-color: #21a1db57;
        background-image: url(../../../static/img/nav-1.png);

        background-repeat: no-repeat;
        // background-size: cover;
        background-size: @a;

        .head_Navigat {
            width: 100%;
            height: 100px;
            background-color: #0000007a;
            // position: fixed;
            // left: 0;
            // top: 0;
            @row();
            padding: 0 20px;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            .head_logo {
                width: 345px;
                height: 100%;
                display: @flex;
                align-items: center;
                cursor: pointer;

                .logo {
                    width: 60px;
                    height: 60px;
                    background-color: #ffffff;
                    border-radius: 50px;
                    overflow: hidden;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: cover;
                    }
                }

                .logo_title {
                    width: 300px;
                    height: @a;
                    font-family: ZhenyanGB-Regular;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 4px;
                    color: #ffffff;
                    margin-left: 20px;
                    line-height: 100px;
                }
            }

            .head_menu {
                width: 750px;
                height: @a;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .menu_Product {
                    width: auto;
                    height: 20px;
                    font-size: 18px;
                }
            }

            .head_phoe {
                width: 300px;
                height: 100%;
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ffffff;
                margin-left: 30px;
                @row();
            }

            .head_regist {
                width: auto;
                height: @a;
                display: flex;
                align-items: center;

                .login {
                    width: 60px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 18px;
                    color: #ffffff;
                    text-align: center;
                    margin-left: 20px;
                    cursor: pointer;
                }

                .regist {
                    width: 60px;
                    height: 40px;
                    cursor: pointer;
                    text-align: center;
                    line-height: 40px;
                    color: #333333;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#21a1db,
                    #21a1db);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    border-radius: 5px;
                    margin-left: 20px;
                }

                .head_user {
                    // width: 230px;
                    width: auto;
                    height: 40px;
                    @Zrow();

                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#21a1db,
                    #21a1db);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    border-radius: 5px;
                    padding: 10px;
                    box-sizing: border-box;
                    font-family: MicrosoftYaHei;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #ffffff;

                    img {
                        width: 30px;
                        height: 30px;
                        object-fit: cover;
                        margin-right: 15px;
                        border-radius: 50%;
                    }
                }

                .trial {
                    width: 110px;
                    height: 40px;
                    cursor: pointer;
                    background-color: #ffffff;
                    border-radius: 20px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #21a1db;
                    @row();
                    margin-left: 20px;
                }
            }

        }

        .head_introduce {
            width: @a;
            height: 630px;
            position: absolute;
            left: 0;
            top: 100px;
            @column();

            .xiangJun_title {
                width: auto;
                height: 47px;
                font-family: ZhenyanGB-Regular;
                font-size: 48px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 5px;
                color: #ffffff;
                text-align: center;
            }

            .xiangJun_desc {
                width: 1050px;
                height: 66px;
                font-family: MicrosoftYaHei;
                font-size: 30px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 3px;
                color: #ffffff;
                margin-top: 77px;

                .desc_text1 {
                    width: 100%;
                    height: 50%;
                    text-align: center;
                }

                .desc_text2 {
                    width: 100%;
                    height: 50%;
                    text-align: center;
                    margin-top: 10px;
                }
            }

            .xiangJun_btn {
                width: 180px;
                height: 50px;
                background-color: #ffffff;
                border-radius: 25px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #21a1db;
                @row();
                margin-top: 74px;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/nav/nav-top.vue